<template>
  <div>
    <el-card class="box-card">
      <div slot="header">
        <span>主题评价内容</span>
      </div>
      <div class="tui-item">
        <div class="tui-flexItmes">
          <!-- 默认模板分类 -->
          <div
            class="tui-itemBox"
            v-for="(item, index) in templateList"
            :key="index"
            slot="reference"
            :style="{
              background: 'url( ' + bgImg[index] + ') no-repeat 100%,center',
            }"
            @click="onClickTeacher(item)"
          >
            <div style="margin: 20px 0; font-size: 18px">{{ item.Title }}</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { GetEditEval_ThemeInfo } from "../../api/api";
export default {
  data() {
    return {
      templateList: [],
      userInfo: {},
      bgImg: [
        require("../../assets/zhutishuoming.png"),
        require("../../assets/teacherItem.png"),
        require("../../assets/patriarch.png"),
        require("../../assets/baby.png"),
      ],
      arr: [
        {
          Eval_ThemeDetailId: 100,
          TempleteId: 0,
          Title: "主题说明",
        },
      ],
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.GetEditEval_ThemeInfo();
  },
  methods: {
    //   教师模块
    onClickTeacher(item) {
      this.$router.push({
        path: "/SubjectEvaluationTeacher",
        query: {
          name: item.Title,
          Eval_ThemeDetailId: item.Eval_ThemeDetailId,
          TempleteId: item.TempleteId,
          ThemeId: this.$route.query.ThemeId,
          Title: this.$route.query.Title,
        },
      });
    },
    GetEditEval_ThemeInfo() {
      const params = {
        ThemeId: this.$route.query.ThemeId,
        TempleteId: this.userInfo.SchoolName == "民京路幼稚园" ? 5 : 1,
      };
      GetEditEval_ThemeInfo(params).then((res) => {
        if (res.data.success) {
          this.templateList = this.arr.concat(res.data.response);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
          this.templateList = [];
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box-card {
  span {
    font-size: 22px;
    font-weight: 600;
  }
  .tui-item {
    min-height: 600px;
    .tui-flexItmes {
      display: flex;
      flex-wrap: wrap;
      .tui-itemBox {
        width: 165px;
        height: 165px;
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-left: 20px;
        background: url("../../assets/baby.png") no-repeat;
        position: relative;
        div {
          position: absolute;
          bottom: -50px;
          left: 0;
          right: 0;
          font-weight: bold;
        }
      }
    }
  }
}
</style>